// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".icon--emoji[data-v-335c864d] {\n  font-style: normal;\n}", "",{"version":3,"sources":["/home/danford/drochat/app/javascript/shared/components/EmojiOrIcon.vue"],"names":[],"mappings":"AACA;EACE,kBAAA;AAAF","file":"EmojiOrIcon.vue","sourcesContent":["\n.icon--emoji {\n  font-style: normal;\n}\n"]}]);
// Exports
module.exports = exports;
